import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRoutes from './routes';
import NotificationCenter from './components/NotificationCenter';
import reportWebVitals from './reportWebVitals';

// "ResizeObserver loop completed with undelivered notifications" é um aviso inofensivo
// do próprio browser (não um bug da aplicação) — mas o overlay de erro do CRA em modo
// dev trata como se fosse um crash e bloqueia a tela. Acontece com frequência em
// sequências rápidas de mudança de layout, como abrir um Modal (react-bootstrap) logo
// após fechar uma lista de opções (SearchSelectField: botão Limpar seguido de +).
// Adiar o callback do ResizeObserver para o próximo frame evita a condição de "loop"
// que dispara o aviso, então o erro nunca chega a ser gerado.
if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppRoutes />
    <NotificationCenter />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
